import { Fragment, useEffect } from 'react';
import { useRouter } from 'next/router';
import moment from 'moment';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/ko';
import { MomentLocaleMapping } from '../../core/constants';
import cookie from '../../core/helpers/cookie';
import chatbot from '../../core/helpers/chatbot';
import analytics from '../../core/analytics/analytics';

type Props = {
  children: React.ReactNode;
};

const LanguageProvider: React.FC<Props> = ({ children }) => {
  const router = useRouter();

  // NOTE: it needs to set locale for moment.js at the fist render to show related contents correctly.
  (async () => {
    moment.locale(MomentLocaleMapping[router.locale as string]);
  })();

  useEffect(() => {
    (async () => {
      moment.locale(MomentLocaleMapping[router.locale as string]);
      cookie.locale.set(router.locale as string);
      chatbot.locale.set(router.locale as string);
      analytics.google.basic.track.locale(router.locale as string);
    })();
  }, [router.locale]);

  return <Fragment key={router.locale}>{children}</Fragment>;
};

export default LanguageProvider;
